import React from 'react';
import { processSteps } from '../mock/mock';

export default function ProcessSteps() {
  return (
    <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-4 relative">
      {processSteps.map((p, i) => (
        <div key={p.step} className="reveal relative rounded-2xl glass p-7">
          <span className="font-display text-5xl font-bold text-slate-200">{p.step}</span>
          <h3 className="font-display text-lg font-semibold text-slate-900 mt-2">{p.title}</h3>
          <p className="text-sm text-slate-500 mt-2 leading-relaxed">{p.desc}</p>
          {i < processSteps.length - 1 && (
            <span className="hidden lg:block absolute top-1/2 -right-3 w-6 h-px bg-gradient-to-r from-[#2563eb]/60 to-transparent" />
          )}
        </div>
      ))}
    </div>
  );
}
